import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MaterialAppModule } from "../../ngmaterial.module";
import { MatSnackBarConfig } from "@angular/material";
import { RouterModule } from "@angular/router";

import { CommonModule } from "../../common/common.module";
import { GatewayDownloadComponent } from "./gateway-download/gateway-download.component";
import { GatewayJoinedComponent } from "./gateway-joined/gateway-joined.component";
import { GatewayPendingComponent } from "./gateway-pending/gateway-pending.component";
import { GatewaysComponent } from "./gateways.component";
import { GatewaysService } from "./gateways.service";
import { GatewaysStatusService } from "./gateways-status.service";
import { GatewaysUiService } from "./gateways.ui.service";
import { GatewayTableDnsComponent } from "./gateway-table-dns/gateway-table-dns.component";
import { GatewayTableHostsComponent } from "./gateway-table-hosts/gateway-table-hosts.component";
import { GatewayTablePortsComponent } from "./gateway-table-ports/gateway-table-ports.component";
import { GenericTableModule } from "../../genericTable";
import { StatusComponent } from "./gateway-joined/status/status.component";
import { PendingAcceptComponent } from "./gateway-pending/pending-accept/pending-accept.component";
import { PrivateGatewayDeactivateGuard } from "./private-gateway-deactivate.guard";
import { GatewayEditWizardService } from "./gateway-edit-wizard/gateway-edit-wizard.service";
import { GatewayEditNameComponent } from "./gateway-edit-wizard/gateway-edit-name/gateway-edit-name.component";
import { GatewayEditIpPortsComponent } from "./gateway-edit-wizard/gateway-edit-ip-ports/gateway-edit-ip-ports.component";
import { GatewayEditDnsComponent } from "./gateway-edit-wizard/gateway-edit-dns/gateway-edit-dns.component";

@NgModule({
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		CommonModule,
		FlexLayoutModule,
		FormsModule,
		GenericTableModule,
		MaterialAppModule,
		ReactiveFormsModule,
		RouterModule
	],
	declarations: [
		GatewayDownloadComponent,
		GatewayJoinedComponent,
		GatewayPendingComponent,
		GatewaysComponent,
		GatewayTableDnsComponent,
		GatewayTableHostsComponent,
		GatewayTablePortsComponent,
		PendingAcceptComponent,
		GatewayEditNameComponent,
		GatewayEditIpPortsComponent,
		GatewayEditDnsComponent,
		StatusComponent
	],
	entryComponents: [
		GatewayTableDnsComponent,
		GatewayTableHostsComponent,
		GatewayTablePortsComponent,
		PendingAcceptComponent,
		GatewayEditNameComponent,
		GatewayEditIpPortsComponent,
		GatewayEditDnsComponent,
		StatusComponent
	],
	providers: [
		GatewaysService,
		GatewayEditWizardService,
		GatewaysUiService,
		GatewaysStatusService,
		MatSnackBarConfig,
		PrivateGatewayDeactivateGuard
	]
})
export class GatewaysModule { }
